import Container from "@/components/container";
import { FaFacebook, FaInstagram, FaLinkedin, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import Image from "next/image";
import { useState } from "react";
import Link from "next/link";
export default function Footer() {
  const [email, setEmail] = useState("");
  const [statusMessage, setStatusMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const handleSubscribe = async () => {
    if (!email) {
      setStatusMessage("Please enter a valid email address.");
      return;
    }
    setIsLoading(true); // Start loading spinner
    setStatusMessage("");
    try {
      const response = await fetch(
        "https://neetsupport.com/members/api/send-magic-link/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        }
      );

      if (response.ok) {
        setStatusMessage("Subscribed successfully!");
        setEmail(""); // Clear the input after successful subscription
      } else {
        const errorData = await response.json();
        setStatusMessage(
          `Subscription failed: ${errorData.message || "Unknown error"}`
        );
      }
    } catch (error) {
      console.error("Error during subscription:", error);
      setStatusMessage("An error occurred. Please try again later.");
    } finally {
      setIsLoading(false); // Stop loading spinner
    }
  };

  return (
    <>
      {/* Mobile Footer */}
      <div className="block md:hidden">
        <MobileFooter
          email={email}
          setEmail={setEmail}
          handleSubscribe={handleSubscribe}
          statusMessage={statusMessage}
          isLoading={isLoading}
        />
      </div>

      {/* Desktop Footer */}
      <div className="hidden md:block">
        <DesktopFooter
          email={email}
          setEmail={setEmail}
          handleSubscribe={handleSubscribe}
          statusMessage={statusMessage}
          isLoading={isLoading}
        />
      </div>
    </>
  );
}

const MobileFooter = ({
  email,
  setEmail,
  handleSubscribe,
  statusMessage,
  isLoading,
}) => {
  return (
    <footer className="relative text-white bg-[#ff9245] py-4 px-4 md:px-10">
      <div className="relative z-10">
        {/* Updates Section */}
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-white">Get Updates!</h2>
          <p className="text-sm">
            Subscribe to our newsletter to receive updates and special
            announcements.
          </p>
          <div className="flex ml-16 sm:ml-52 mt-4 items-center bg-transparent border border-white rounded-md overflow-hidden w-fit">
            {/* Input Box */}
            <input
              type="email"
              placeholder="Enter Email ID"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-48 px-4 py-2 text-sm text-white placeholder-white bg-transparent border-0 focus:outline-none focus:ring-2 focus:ring-white"
            />

            {/* Button */}
            <button
              onClick={handleSubscribe}
              className="px-4 py-2 bg-white text-[#ff9245] font-bold text-sm hover:bg-[#ffae6d] transition-colors flex items-center justify-center"
            >
              {isLoading ? (
                <span className="animate-spin h-5 w-5 border-2 border-t-transparent border-white rounded-full"></span>
              ) : (
                "Sign Up"
              )}
            </button>
          </div>

          {statusMessage && <p className="mt-2 text-sm">{statusMessage}</p>}
        </div>

        {/* Contact Section */}
        <div className="text-center">
          {/* <p className="font-bold">Address 1:</p>
          <p>
            4th Floor, 415, NEET Support,
            <br />
            Plot No. 21 & 21A, Sector 142, Noida, Uttar Pradesh 201304
          </p> */}

          <p className="mt-3 font-bold">Address:</p>
          <p>
            Ground Floor, C-127,
            <br />C Block, Sector 63, Noida, Uttar Pradesh 201301
          </p>

          <p className="mt-4 font-bold">
            Email:
            <a
              href="mailto:info@neetsupport.com"
              className="text-white hover:underline ml-1"
            >
              info@neetsupport.com
            </a>
          </p>

          <p className="mt-2 font-bold">
            Phone No:
            <a
              href="tel:+919560465351"
              className="text-white hover:underline ml-1"
            >
              +91 95604 65351, +91 99109 89253
            </a>
          </p>
        </div>

        {/* Links and Social Media */}
        <div className="text-center space-y-2">
          <div className=" justify-center space-x-6 list-none grid grid-cols-3 gap-2">
            <li>
              <a href="/About-Us" className="hover:underline">
                About Us
              </a>
            </li>
            <li>
              <a href="/services" className="hover:underline">
                Services
              </a>
            </li>
            <li>
              <a href="/blogs" className="hover:underline">
                Blogs
              </a>
            </li>
          </div>
          <div className=" justify-center space-x- list-none grid grid-cols-2 gap-0">
            <li>
              <a
                href="/collegeList"
                className="hover:underline whitespace-nowrap"
              >
                Medical Colleges
              </a>
            </li>
            <li>
              <a
                href="/counselling"
                className="hover:underline whitespace-nowrap"
              >
                Counselling Bodies
              </a>
            </li>
          </div>

          <div className="flex justify-center space-x-4 mt-6 mb-2">
            <a
              href="https://www.facebook.com/NEETSupport.comINDIA"
              target="_blank"
              aria-label="Facebook"
            >
              <FaFacebook size={20} color="#ffffff" />
            </a>
            <a
              href="https://www.instagram.com/neetsupportindia/"
              target="_blank"
              aria-label="Instagram"
            >
              <FaInstagram size={20} color="#ffffff" />
            </a>
            <a
              href="https://x.com/neet_support_"
              target="_blank"
              aria-label="Twitter"
            >
              <FaXTwitter size={20} color="#ffffff" />
            </a>
            <a
              href="https://www.linkedin.com/company/neetsupport/"
              target="_blank"
              aria-label="LinkedIn"
            >
              <FaLinkedin size={20} color="#ffffff" />
            </a>
            <a
              href="https://www.youtube.com/@NEETSupportIndia"
              target="_blank"
              aria-label="Youtube"
            >
              <FaYoutube size={20} color="#ffffff" />
            </a>
          </div>
        </div>

        {/* Footer Bottom Section */}
        <div className="mt-4 border-t border-white text-center text-[15px] relative z-10 text-[#fff]">
          <div className="text-nowrap">
            © {new Date().getFullYear()} NeetSupport (MineCart). All Rights
            Reserved.
          </div>
          <div className=" mt-2 flex justify-center space-x-4">
            <a href="privacy-policy" className="hover:underline">
              Privacy Policy
            </a>
            <a href="refund-policy" className="hover:underline">
              Refund Policy
            </a>
            <a href="terms" className="hover:underline">
              Terms of Use
            </a>
            <a href="/sitemap.xml" className="hover:underline">
              Sitemap
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

const DesktopFooter = ({
  email,
  setEmail,
  handleSubscribe,
  statusMessage,
  isLoading,
}) => {
  return (
    <footer
      className="relative pt-[100px] lg:pt-[70px] xl:pt-[160px] 2xl:pt-[300px] overflow-hidden text-[15px] leading-relaxed w-full"
      style={{
        position: "relative",
        width: "100%",
        minHeight: "350px", // Default height
        minHeight: "400px", // Adjust height for large screens
      }}
    >
      {/* Background Image Container */}
      <div
        className="absolute inset-0 w-full h-full"
        style={{ width: "100%", height: "100%", zIndex: "-1" }}
      >
        <Image
          src="/images/Footers.png"
          alt="Graduation background"
          fill
          style={{ objectFit: "cover", objectPosition: "top center" }}
          quality={100}
          priority
        />
      </div>

      <Container>
        <div className="pt-40 flex flex-col md:flex-row lg:flex-row items-stretch justify-around relative z-10 text-white">
          {/* Update Section */}
          <div className="update-section md:ml-[20px] lg:ml-0 mb-8 lg:mb-0 max-w-sm lg:border-r lg:border-white lg:pr-10 lg:pl-4 md:pt-6 h-full">
            <h2 className="text-2xl font-bold mb-5 text-[#5a5a5a] md:text-white">
              Get Updates!
            </h2>
            <p className="text-base mb-3 text-[#5a5a5a] md:text-white">
              Subscribe to our newsletter to receive updates and special
              announcements.
            </p>
            <div className="flex mt-4 items-center bg-transparent border border-white rounded-md overflow-hidden w-fit">
              {/* Input Box */}
              <input
                type="email"
                placeholder="Enter Email ID"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-48 px-4 py-2 text-sm text-white placeholder-white bg-transparent border-0 focus:outline-none focus:ring-2 focus:ring-white"
              />

              {/* Button */}
              <button
                onClick={handleSubscribe}
                className="px-4 py-2 bg-white text-[#ff9245] font-bold text-sm hover:bg-[#ffae6d] transition-colors flex items-center justify-center"
              >
                {isLoading ? (
                  <span className="animate-spin h-5 w-5 border-2 border-t-transparent border-white rounded-full"></span>
                ) : (
                  "Sign Up"
                )}
              </button>
            </div>
            {statusMessage && <p className="mt-2 text-sm">{statusMessage}</p>}
          </div>

          {/* Contact Section */}
          <div className="contact-section text-left lg:text-left text-[15px] md:text-[16px] lg:border-r lg:border-white lg:px-8 lg:pr-10 md:pt-6 h-full">
            {/* <p>
              <strong>Address 1:</strong>
              <br />
              <span className="italic">
                4th Floor, 415, NEET Support, <br />
                Plot No. 21 & 21A, Sector 142, Noida, Uttar Pradesh 201304
              </span>
            </p> */}

            <p className="mt-3">
              <strong>Address:</strong>
              <br />
              <span className="italic">
                Ground Floor, C-127, <br />C Block, Sector 63, Noida, Uttar
                Pradesh 201301
              </span>
            </p>

            <p className="mt-3 font-bold">
              Email:
              <a
                href="mailto:info@neetsupport.com"
                className="text-white hover:underline ml-2"
              >
                info@neetsupport.com
              </a>
            </p>

            <p className="mt-1 font-bold">
              Phone No:
              <a
                href="tel:+919560465351"
                className="text-white hover:underline ml-2"
              >
                +91 95604 65351 , +91 99109 89253
              </a>
            </p>
          </div>

          {/* Links Section */}
          <div className="links-section md:pt-5 lg:px-8 lg:pl-10">
            <ul className="flex flex-col space-y-1 pt-8 font-bold text-[15px]">
              <li>
                <a href="/About-Us" className="hover:underline">
                  About Us
                </a>
              </li>
              <li>
                <a href="/services" className="hover:underline">
                  Services
                </a>
              </li>
              <li>
                <a href="/blogs" className="hover:underline">
                  Blogs
                </a>
              </li>
              <li>
                <a href="/collegeList" className="hover:underline">
                  Medical Colleges
                </a>
              </li>
              <li>
                <a href="/counselling" className="hover:underline">
                  Counselling Bodies
                </a>
              </li>
            </ul>

            <div className="social-icons flex space-x-6 mt-8">
              <a
                href="https://www.facebook.com/NEETSupport.comINDIA"
                aria-label="Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook size={20} color="#ffffff" />
              </a>
              <a
                href="https://www.instagram.com/neetsupportindia/"
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram size={20} color="#ffffff" />
              </a>
              <a
                href="https://x.com/neet_support_"
                aria-label="Twitter"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaXTwitter size={20} color="#ffffff" />
              </a>
              <a
                href="https://www.linkedin.com/company/neetsupport/"
                aria-label="LinkedIn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin size={20} color="#ffffff" />
              </a>
              <a
                href="https://www.youtube.com/@NEETSupportIndia"
                target="_blank"
                aria-label="Youtube"
              >
                <FaYoutube size={20} color="#ffffff" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Links and Copyright */}
        <div className="mt-4 border-t border-white text-center text-[15px] relative z-10 text-[#fff]">
          <div>
            © {new Date().getFullYear()} NeetSupport (MineCart). All Rights
            Reserved.
          </div>
          <div className="flex justify-center space-x-4">
            <Link href="/privacy-policy" className="hover:underline">
              Privacy Policy
            </Link>
            <Link href="/refund-policy" className="hover:underline">
              {" "}
              Refund Policy
            </Link>
            {/* <a href="refund-policy" className="hover:underline">
              Refund Policy
            </a> */}
            <Link href="/terms" className="hover:underline">
              {" "}
              Terms of Use
            </Link>

            <Link href="/sitemap.xml" className="hover:underline">
              {" "}
              Sitemap
            </Link>

            {/* <a href="terms" className="hover:underline">
              Terms of Use
            </a> */}
          </div>
        </div>
      </Container>
    </footer>
  );
};
